/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */

// styles
import {
  Container,
  SquaresMenuWrapper,
  Title,
  Content,
  SegmentNavigationWrapper,
  NavList,
  ItemMenu,
  Image,
  Label,
} from './SquaresMenu.styles';

export function SquaresMenu() {
  return (
    <SquaresMenuWrapper>
      <Container>
        <Title>All shipping modes optimized for your needs.</Title>
        <Content>
          Access instant, dynamic capacity to move your overland <br /> freight
          — no matter the mode or market.
        </Content>
      </Container>

      <SegmentNavigationWrapper>
        <Container>
          <NavList>
            <ItemMenu href="/ftl/">
              <Image>
                <source
                  srcSet={`/images/shipper/squares-menu/square-menu-ftl.jpg`}
                  media="(min-width: 768px)"
                />
                <img
                  width="325"
                  height="130"
                  src={`/images/shipper/squares-menu/square-menu-ftl-mobile.jpg`}
                  alt="FTL truck"
                />
              </Image>
              <Label>FULL TRUCKLOAD</Label>
            </ItemMenu>
            <ItemMenu href="https://lp.loadsmart.com/ltl-less-than-truckload-from-loadsmart">
              <Image>
                <source
                  srcSet={`/images/shipper/squares-menu/square-menu-ltl.jpg`}
                  media="(min-width: 768px)"
                />
                <img
                  width="325"
                  height="130"
                  src={`/images/shipper/squares-menu/square-menu-ltl-mobile.jpg`}
                  alt="LTL on warehouse"
                />
              </Image>
              <Label>LESS THAN TRUCKLOAD</Label>
            </ItemMenu>
            <ItemMenu href="/port-drayage/">
              <Image>
                <source
                  srcSet={`/images/shipper/squares-menu/square-menu-port-drayage.jpg`}
                  media="(min-width: 768px)"
                />
                <img
                  width="325"
                  height="130"
                  src={`/images/shipper/squares-menu/square-menu-port-drayage-mobile.jpg`}
                  alt="Port load"
                />
              </Image>
              <Label>PORT DRAYAGE</Label>
            </ItemMenu>
            <ItemMenu href="/mode-optimization/">
              <Image>
                <source
                  srcSet={`/images/shipper/squares-menu/square-menu-mode-optimization.jpg`}
                  media="(min-width: 768px)"
                />
                <img
                  width="325"
                  height="130"
                  src={`/images/shipper/squares-menu/square-menu-mode-optimization-mobile.jpg`}
                  alt="Train mode"
                />
              </Image>
              <Label>MODE OPTIMIZATION</Label>
            </ItemMenu>
          </NavList>
        </Container>
      </SegmentNavigationWrapper>
    </SquaresMenuWrapper>
  );
}
